// extracted by mini-css-extract-plugin
export var centerText = "_d5-8";
export var container = "_d5-0";
export var doughnutContainer = "_d5-7";
export var legend = "_d5-a";
export var legendItemColorDisplay = "_d5-b";
export var legendItemLabel = "_d5-d";
export var legendItemValue = "_d5-c";
export var lg = "_d5-5";
export var maxWidth = "_d5-9";
export var md = "_d5-4";
export var responsive = "_d5-6";
export var sm = "_d5-3";
export var xs = "_d5-2";
export var xxs = "_d5-1";